import React, { useState, useEffect } from "react";
import { Theme, useTheme } from '@mui/material/styles'
import { makeStyles,} from "@mui/styles";
import {
  Button,
  Chip,
  FormControl,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import { getSalesOfficesAndRoutes } from "../../utils/GetPlanning";
import requestMissingContexts, { determineConfig, displayConfig } from "../../utils/GetContext";
import { useLocalStorage } from "../../componentUtils/LocalStorage";

interface Inputs {
  onSelectionChange: any;
}

interface HeaderState {
  isLoaded: boolean,
  allDeliveringPlants: any,
  deliveringPlants: string[],
  dateFrom: string,
  dateTo: string,
}

interface DeliveringPlant {
  // salesOffice: string,
  deliveringPlant: string;
  name: string,
}

export const tableHeightReducePx = 75;
export default function DateRangeHeader(props: Inputs) {
  const theme: Theme = useTheme();
  const useStyles = makeStyles((theme: Theme) => ({
    cont: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    grid: {
      marginLeft: theme.spacing(1),
    },
    load: {
      textAlign: "center",
      justify: "center",
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
      maxHeight:'100px',
      overflow:'auto'
    },
    chip: {
      margin: 2,
    },
    formControl: {
      minWidth: 200,
      margin: theme.spacing(1),
    },
  }));

  var dateFrom  = new Date();
  dateFrom.setDate(dateFrom.getDate() - 1);
  var dateTo = new Date();
  const dateFromStr = dateFrom.toISOString().split('T')[0];
  const dateToStr = dateTo.toISOString().split('T')[0];

  const classes = useStyles();
  const [state, setState] = useState<HeaderState>({
    isLoaded: false,
    allDeliveringPlants: [],
    deliveringPlants: [],
    dateFrom: dateFromStr,
    dateTo: dateToStr,
  });

  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [defaultSalesOffice,] = useLocalStorage("SETTINGS.defaultSalesOffice", '');

  useEffect(() => {
    if (state.isLoaded) return;

    getSalesOfficesAndRoutes(salesOrg.toString()).then(
      (v:any) => {
        const r_so:any[] = v.plants;
        const r_rt:any[] = v.routes;
        if (r_so && r_rt) {
          requestMissingContexts(["PLANTS"]).then((ctx) => {
            const contexts:any = ctx;
            var deliveringPlants: Array<DeliveringPlant> = [];
            for (var i=0; i<r_so.length; i++) {
              const so = r_so[i].plant;
              const desc = so + ": " + determineConfig(
                contexts,
                "PLANTS",
                so || ""
              );
              const deliveringPlant:DeliveringPlant = {deliveringPlant: so, name: desc};
              deliveringPlants.push(deliveringPlant);
            }
            setState({
              ...state,
              isLoaded: true,
              allDeliveringPlants: deliveringPlants,
              deliveringPlants:defaultSalesOffice?[defaultSalesOffice]:[],
            });
          });
        }
      }
    )
  }, [state]);

  const handleSOChange = (event: any) => {
    // event.persist();
    let value = event.target.value;
    if (value) {
      setState({...state, deliveringPlants: value});
    }
  }

  const handleDateFromChange = (event: any) => {
    event.persist();
    setState({...state, dateFrom: event.target.value});
  }

  const handleDateToChange = (event: any) => {
    event.persist();
    setState({...state, dateTo: event.target.value});
  }

  const getStyles = (key: string, arr: string[]) => {
    return {
      fontWeight:
        arr.indexOf(key) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }


  return (
    <Paper className={classes.cont}>
      <Grid className={classes.grid} container spacing={3}>
        <Grid item lg={2} md={2} xl={2} xs={2}>
        <FormControl className={classes.formControl} fullWidth>
        <InputLabel id="select-multiple-so-label">Delivery Plant</InputLabel>
        <Select
          multiple
          fullWidth
          value={state.deliveringPlants || ""}
          onChange={handleSOChange}
          input={<Input id="select-multiple-so" />}
          renderValue={(selected: any) => (
            <div className={classes.chips}>
              {selected.map((value: any) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {state.allDeliveringPlants.map((option: any) => (
            <MenuItem key={option.deliveringPlant} value={option.deliveringPlant} style={getStyles(option.deliveringPlant, state.allDeliveringPlants)}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
        </FormControl>
        </Grid>

        <Grid item lg={2} md={2} xl={2} xs={2}>
          <TextField label="Date From" fullWidth={true} type="date" value={state.dateFrom} inputProps={{ min: "2000-01-01", max: "9999-12-30" }} InputLabelProps={{ shrink: true }}  onChange={(ce)=>handleDateFromChange(ce)}/>
        </Grid>
        <Grid item lg={2} md={2} xl={2} xs={2}>
          <TextField label="Date To" fullWidth={true} type="date"  value={state.dateTo} inputProps={{ min: "2000-01-01", max: "9999-12-30" }}  InputLabelProps={{ shrink: true }}  onChange={(ce)=>handleDateToChange(ce)}/>
        </Grid>
        <Grid item className={classes.load} lg={2} md={2} xl={2} xs={2}>
          <Button onClick={() => props.onSelectionChange(state.deliveringPlants, state.dateFrom, state.dateTo)}>Load Data</Button>
        </Grid>
      </Grid>
    </Paper>
  );
}
